<template>
  <div class="index-wrap">
    <div class="top-bg">
      <img src="../../../assets/bg.jpg" />
    </div>
    <div class="btn-box">
      <a :href="iosUrl">{{iosVersion ? 'V'+iosVersion : ''}}  IOS下載</a>
      <a :href="androidUrl">{{androidVersion ? 'V'+androidVersion : ''}}  Android下載</a>
    </div>
  </div>
</template>

<script>
import { getBaseSiteConfig } from "@/api/index";

export default {
  data() {
    return {
      iosUrl: '#',
      iosVersion: '',
      androidUrl: '#',
      androidVersion: '',
    }
  },
  mounted() {
    getBaseSiteConfig()
      .then((res) => {
        if (res.code === 1) {
          this.androidUrl = res.data.android_download;
          this.androidVersion = res.data.android_version;
          this.iosUrl = res.data.ios_download;
          this.iosVersion = res.data.ios_version;
        }
      })
      .catch(() => {});
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.index-wrap {
  max-width: 640px;
  margin: 0 auto;
  height: 100vh;
  background-color: #ffffff;
  background-image: url("../../../assets/footerBg.png");
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: contain;
}
.top-bg {
  font-size: 0;
}
.top-bg img {
  max-width: 640px;
  width: 100%;
}
.btn-box {
  text-align: center;
  font-size: 0;
  margin-top: 0.4rem;
}
.btn-box > a {
  display: inline-block;
  text-decoration: none;
  background-color: #3968fb;
  color: #ffffff;
  width: 180px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 16px;
  margin: 10px 20px 20px 20px;
  outline: none;
}
@media (max-width: 767px) {
  .btn-box > a {
    display: inline-block;
    text-decoration: none;
    background-color: #3968fb;
    color: #ffffff;
    width: 70%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    font-size: 16px;
    margin: 10px 20px 20px 20px;
    outline: none;
  }
}
</style>